export default "__VITE_ASSET__BqH8Rejb__"